/*
 * Ctrl+Enter (⌘+Enter on a Mac) is the "go ahead" key on keyboard-first
 * screens like the POS: checkout, add a payment, complete the sale. A
 * modifier is required on purpose, so a stray plain Enter never moves money.
 */

export const IS_MAC = typeof navigator !== "undefined" && /Mac|iPhone|iPad/i.test(navigator.userAgent);

/** How to show the shortcut on a button: "⌘ Enter" or "Ctrl Enter". */
export const SUBMIT_SHORTCUT_LABEL = IS_MAC ? "⌘ Enter" : "Ctrl Enter";

/** Pass a native KeyboardEvent (for a React event, its `nativeEvent`). */
export function isSubmitShortcut(e: KeyboardEvent): boolean {
    return e.key === "Enter" && (e.ctrlKey || e.metaKey) && !e.altKey && !e.shiftKey && !e.isComposing;
}

/** "⌘ P" or "Ctrl P" — print the receipt that's open. */
export const PRINT_SHORTCUT_LABEL = IS_MAC ? "⌘ P" : "Ctrl P";

/**
 * Ctrl/⌘+P. Also matched by the physical P key (`code`), so it still works
 * with a Bangla (or any non-Latin) keyboard layout active.
 */
export function isPrintShortcut(e: KeyboardEvent): boolean {
    return (
        (e.ctrlKey || e.metaKey) &&
        !e.altKey &&
        !e.shiftKey &&
        (e.code === "KeyP" || e.key.toLowerCase() === "p")
    );
}
